import { Link } from "react-router-dom";
import { Reveal } from "@/components/landing/Reveal";

const CARDS = [
  {
    img: "/images/rescue.jpg",
    title: "Rescue",
    desc: "Our field team responds to injured and abandoned animals across Mumbai, seven days a week. Every animal receives immediate care — no animal is ever refused.",
  },
  {
    img: "/images/hospital.jpg",
    title: "Treat",
    desc: "At our Malad hospital — 100-bed capacity, ICU, operating theatres, digital X-ray — vets treat wounds, fractures, and illness. Every treatment update is posted to the animal's page.",
  },
  {
    img: "/images/recovered.jpg",
    title: "Release, Adopt or Sanctuary",
    descBefore: "Healed animals return to their streets or find loving homes. Those who can never go back live out their lives at our 10+ acre cage-free ",
    descLinkText: "sanctuary",
    descAfter: " in Kolad, home to 500+ animals.",
  },
];

export function SupportCards() {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="landing-support-cards">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-14 max-w-2xl mx-auto">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-amtm-teal mb-4">
            The Process
          </p>
          <h2 className="font-display text-3xl md:text-4xl text-amtm-text">How your support helps</h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                className="group bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.06)] hover:shadow-[0_16px_40px_rgba(0,0,0,0.12)] hover:-translate-y-1 transition-all duration-300 overflow-hidden h-full flex flex-col"
                data-testid={`support-card-${c.title.toLowerCase().split(",")[0].replace(/\s+/g, "-")}`}
              >
                <div className="h-56 md:h-64 overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="w-full h-full object-cover ease-out group-hover:scale-[1.03]"
                    style={{ transition: "transform 400ms" }}
                  />
                </div>
                <div className="p-6 md:p-8">
                  <h3 className="font-display text-xl text-amtm-teal mb-2">{c.title}</h3>
                  {c.descLinkText ? (
                    <p className="text-sm text-amtm-textMuted leading-relaxed">
                      {c.descBefore}
                      <Link to="/sanctuary" className="text-amtm-teal underline hover:text-amtm-teal/80" data-testid="support-card-sanctuary-link">
                        {c.descLinkText}
                      </Link>
                      {c.descAfter}
                    </p>
                  ) : (
                    <p className="text-sm text-amtm-textMuted leading-relaxed">{c.desc}</p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
